import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useHistory, useLocation } from "react-router-dom";
import { Auth, API } from "aws-amplify";
import LoaderButton from "../components/LoaderButton";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { onError } from "../libs/errorLib";
import { checkYMD, validateSimpleDateFormat } from "../libs/utilsLib";
import PasswordForm from "./PasswordForm";
import PasswordConfirm from "./PasswordConfirm";
import ConfirmationCodeForm from "./ConfirmationCodeForm";
import "./Signup.css";

export default function SetupPassword(props) {
  const [refreshCount, setRefreshCount] = useState(0);
  const search = useLocation().search;
  const userId = new URLSearchParams(search).get('mi'); // member ID
//  const mt = new URLSearchParams(search).get('mt');  // Member Type
//  const [opType, setOpType] = useState(opt ? opt : 1);
  const mId = new URLSearchParams(search).get('i'); // userId
  const [hasEmail, setHasEmail] = useState(true);

  useEffect(() => {
    console.log('useEffect called...');
    window.scrollTo(0, 0);
    const onLoad = async () => {
      if (isAuthenticated && isAdmin) {
        setPage('input');        
      }
      console.log('onLoad called...');
      updateValidationMessages();
      const anonymousUser = await Auth.currentCredentials();
      try {
        const m = await API.get("sakurajima", `/members/${mId}`);
        console.log(m);
        console.log('userId = ' + userId);
        if (m.authStatus == "Assigned") {
          const elmt = document.getElementById('confirm');
          elmt.disabled = true;
          throw new Error('ユーザーは既にパスワード登録されています。');
	}
        if (m.data != userId) {
          throw new Error('不正なアクセスです。');
        }

        if (!(m.affiliationEmail && m.affiliationEmail.length > 0)) {
          console.log('setHasEmail to false');
          setHasEmail(false);
	}
        setMember(m);
        if (m.memType == 6) {
          var element = document.getElementById("menuLogin");
          element.setAttribute("href", "/login?m=am");
        }
      } catch (e) {
        if (e.response) {
          if (e.response.data && e.response.data.error) {
            if (e.response.data.error == 'Item not found.') alert('メンバーデータが見つかりません');
		  return;
	  }
        }
        onError(e);
      }
    };
    onLoad();
  },[]);

  const hideEmailFields = () => {
/*
//    document.getElementById('affiliationEmail').style.display = 'none';
    const ffields = document.getElementsByClassName('emailFormField');
    for (let i=0; i < ffields.length; i++) {
      ffields[i].style.display = 'none';
    }
*/
  };

  const [fields, messages, handleFieldChange, doValidation] = useFormFields({
    loginId: userId,
    password: "",
    passwordConfirmation: "",
    confirmationCode: "",
    affiliationEmail: "",
    affiliationEmailConfirmation: ""
  },
  {
    loginId: {n:"", f: (value) => { 
      return '';
    }},
    password: {n:"", f: (value) => {
      console.log('password ...');
	if (value) {
          if(value.match(/^(?=.*?[a-z])(?=.*?\d)[a-z\d]{8,30}$/i)){
            return '';
          }else{
            return 'パスワードは半角英数字をそれぞれ1種類以上含む8文字以上30文字以下で入力してください。';
          }
	}
      else { 
        return 'パスワードは必須です';
      }
    }},
    passwordConfirmation: {n:"", f: (value) => {
      if (value) {
        setPasswordMismatchMessage('');
        return ''; 
      } else { 
        return 'パスワード（確認用）は必須です';
      }
    }},
    affiliationEmail: {n:"", f: (value) => {
      console.log(value);
      console.log(hasEmail);
      const myElmt = document.getElementById('affiliationEmail');
      if (!myElmt) return '';
      const len = myElmt.parentElement.parentElement.classList.length;
      if (len == 0) {
        if (!value) return 'Emailを入力してください。';
        if (value.match(/^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/) == null) return 'Email アドレスは半角で入力してください。';
        const arr = value.split('@');
        if (arr.length != 2 || arr[0].length < 1 || arr[1].length < 1 || arr[1].split('.').length < 2)  return 'Email アドレスの形式が不正です。';
      }
      return '';
    }},
    affiliationEmailConfirmation: {n:"", f: (value) => {
      console.log(value);
      
      const myElmt = document.getElementById('affiliationEmailConfirmation');
      if (!myElmt) return '';
      const len = myElmt.parentElement.parentElement.classList.length;
      if (len == 0) {
        const org = document.getElementById('affiliationEmailConfirmation').value;
        if (!value) return 'Email（確認用）を入力してください。';
        if (value.match(/^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/) == null) return 'Email アドレスは半角で入力してください。';
        const arr = value.split('@');
        if (arr.length != 2 || arr[0].length < 1 || arr[1].length < 1 || arr[1].split('.').length < 2)  return 'Email アドレスの形式が不正です。';
        if (org == value) setEmailMismatchMessage('');
      }

      return '';
    }},
    confirmationCode: {n:"", f: (value) => {
      if (value)
        return ''; 
      else {
        console.log('check !! ' + document.getElementById('confirmationCode'));
        if (document.getElementById('confirmationCode') == null) return '';
        return '確認コードは必須です';
      }
    }}
 });

  const [emailMismatchMessage, setEmailMismatchMessage] = useState('');
  const [passwordMismatchMessage, setPasswordMismatchMessage] = useState('');

  const history = useHistory();
  const { isAuthenticated, userHasAuthenticated, isAdmin } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState("pp"); // Privacy Policy as default
  const [member, setMember] = useState(null);

  function updateValidationMessages() {
    console.log('updateValidationMessages...');
      for(let key in messages) {
	  console.log(key + ' = ' + messages[key].n);
          const  mElmt = document.getElementById(key+'Message');
          if (mElmt)
            mElmt.textContent = messages[key].n;

      }
  }

  function validateForm() {
//    console.log(messages);
    let b = doValidation();
    return b; 
  }

  function validateConfirmationForm() {
    //return fields.confirmationCode.length > 0;
    return true;
  }

  function valocator(name, value) {
  }

  function handleNext(event) {
    event.preventDefault();
    if (!validateForm()) {
      updateValidationMessages();
      console.log("Messages.....");
        console.log(messages);
	let hasErr = false;
        for (const elm of Object.keys(messages)) {
	  if (messages[elm].n.length > 0) {
            hasErr = true;
            console.log(elm);
            document.getElementById(elm).scrollIntoView();
            break;
          }
        }
//        if (!hasErr)


      return false;
    }
    if (fields.password != fields.passwordConfirmation) {
      console.log('password mismatch!!!');
      setPasswordMismatchMessage('パスワードとパスワード（確認用）の入力が一致していません。');
      return false;
    }
    if (!hasEmail && fields.affiliationEmail != fields.affiliationEmailConfirmation) {
      setEmailMismatchMessage('EmailとEmail（確認用）の入力が一致していません。');
      return false;
    }
    console.log('handleOnNext...');
    console.log(event);
    setPage('confirm');
    return false;
  }

  async function handleSubmit(event) {
    event.preventDefault();

    setIsLoading(true);

    try {
      const newUser = await Auth.signUp({
        username: fields.loginId.trim(),
        password: fields.password.trim(),
        attributes: {
            email: hasEmail ? member.affiliationEmail : fields.affiliationEmail,
            preferred_username: mId,   // optional - memberId
        }
      });
      setIsLoading(false);
//      setNewUser(newUser);
    } catch (e) {
      onError(e);
      setIsLoading(false);
    }
  }

  async function handleConfirmationCode(event) {
    event.preventDefault();

    console.log('handleConfirmationCode...');
      
    if (!validateForm()) {
      updateValidationMessages();
      console.log("Messages.....");
        console.log(messages);
	let hasErr = false;
        for (const elm of Object.keys(messages)) {
	  if (messages[elm].n.length > 0) {
            hasErr = true;
            console.log(elm);
            document.getElementById(elm).scrollIntoView();
            break;
          }
        }
      return false;
    }

    setIsLoading(true);

    try {
      await Auth.confirmSignUp(fields.loginId.trim(), fields.confirmationCode.trim());
      const id = member.pk;
      const r = await API.put('sakurajima', `/authStatus/${id}`, {
        body: hasEmail ? { authStatus: "Assigned" } : { authStatus: "Assigned", email: fields.affiliationEmail }
      });
      console.log(r);
      setIsLoading(false);
      setPage('complete');
    } catch (e) {
      onError(e);
      setIsLoading(false);
    }
  }

  async function handleConfirmationSubmit(event) {
    event.preventDefault();

    setIsLoading(true);

    console.log('handleConfirmationSubmit...');
    try {
      const newUser = await Auth.signUp({
        username: fields.loginId,
        password: fields.password,
        attributes: {
            email: hasEmail ? member.affiliationEmail : fields.affiliationEmail,
            preferred_username: mId,   // optional - memberId
        }
      });
      setPage('code');
      setIsLoading(false);
//      setNewUser(newUser);
    } catch (e) {
      console.log('cachch errors on page');
      console.log(e);
      if (e.message && e.message == 'User already exists') {
          if (window.confirm('このユーザーは既に登録済みです。確認コードを再送しますか？\n(パスワードは前回登録したものになります)')) {
	      console.log('resend confirmation code');
              const r = await Auth.resendSignUp(fields.loginId);
              console.log(r);
              setPage('code');
              setIsLoading(false);
              return;
	  }
          console.log('nothing resend');
          setIsLoading(false);
          return;
      }
      onError(e);
      setIsLoading(false);
    }

    setIsLoading(false);
  }

  function renderCompletionView() {
    if (member.memType == 6) {
      var element = document.getElementById("menuLogin");
      element.setAttribute("href", "/login?m=am");
    }
    return (
	    <p><span class="fWB">ログインID（会員番号）: {fields.loginId} のパスワードの設定が完了しました。</span><br/>
                  日本臨床スポーツ医学会ホームページより「会員専用サイト」にアクセスしてログインが可能です。</p>
    );
  }

  const back = (event) => { 
      console.log(event.target.id);
      console.log('hasEmail = ' + hasEmail);
      setPage('input');
  };

  function renderConfirmationForm() {
    return (
      <>
        <div id="registration" className="confirm">
          <section>
            <PasswordConfirm 
              fields={fields}
              hasEmail={hasEmail}
            />
        <Form onSubmit={handleConfirmationSubmit}>
        <div className="btn">
          <Button id="prev" active size="lg" active onClick={ back } >
            戻る
          </Button>
          <LoaderButton
            active
            size="lg"
            type="submit"
            id="regist"
            variant="success"
            isLoading={isLoading}
            disabled={!validateConfirmationForm()}
          >
          送信
          </LoaderButton>
        </div>
        </Form>
          </section>
        </div>
      </>
    );
  }

  function renderCodeForm() {
    return (
        <>
      <section>
      <Form onSubmit={handleConfirmationCode}>
        <div id="registration" className="form">
          <div className="inner">
            <ConfirmationCodeForm fields={fields} handleFieldChange={handleFieldChange}
               messages={messages}
            />

        <LoaderButton
          block
          size="lg"
          type="submit"
          variant="success"
          isLoading={isLoading}
          id="confirm"
        >
          送信
        </LoaderButton>
      </div>
          </div>
        </Form>
        </section>
    {/*        <ScrollToTop/> */}
      </>
    );
  }

  function renderForm() {
    return (
        <>
      <section>
      <Form onSubmit={handleNext}>
        <div id="registration" className="form">
          <div className="inner">
            <PasswordForm fields={fields} handleFieldChange={handleFieldChange}
               passwordMismatchMessage={passwordMismatchMessage}
               emailMismatchMessage={emailMismatchMessage}
               messages={messages}
               hasEmail={hasEmail}
            />

        <LoaderButton
          block
          size="lg"
          type="submit"
          variant="success"
          isLoading={isLoading}
          id="confirm"
        >
          次へ
        </LoaderButton>
      </div>
          </div>
        </Form>
        </section>
    {/*        <ScrollToTop/> */}
      </>
    );
  }

  return (
    <div className="Signup">
      <main>
        <h1 id="page_title">ログイン情報パスワード設定 </h1>
      <div className="container">
        <div id="sub_page">
          { page === "confirm" ? renderConfirmationForm() : (page == 'code' ? renderCodeForm() : (page === "complete" ? renderCompletionView() :  renderForm())) }
        </div>
      </div>
      </main>
    </div>
  );
}
